document.addEventListener('DOMContentLoaded', function (e) {
	// Contact form
	const form = document.querySelector<HTMLFormElement>('form.contact-form');
	if (form) {
		form.addEventListener('submit', async ev => {
			const submit = form.querySelector<HTMLInputElement>('input[type="submit"]');
			if (!submit) {
				console.warn('Form has no submit button:', form)
				return
			}

			ev.preventDefault();

			const inputs = form.querySelectorAll('input, textarea');

			submit.value = 'Sending...'

			const res = await fetch(form.action, {
				method: form.method,
				body: new FormData(form),
				headers: {
					Accept: 'application/json'
				}
			})

			if (res.ok) {
				submit.value = 'Sent!'
				inputs.forEach(inp => inp.setAttribute('disabled', 'true'))
			} else {
				submit.value = 'Submit error'
			}
		})
	}
})
